import { connect } from 'react-redux';

import StickerDrop from '~/Components/Global/Stickers/StickerDrop/StickerDrop';

import {
  dropSticker,
  moveSticker,
  deleteSticker,
  resizeSticker,
  changeStarted,
  changeEnded,
} from '~/Redux/Modules/DroppedStickers';

const mapStateToProps = state => {
  return {
    stickers: state.DroppedStickers.data,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    dropSticker: (data, date, view) => dispatch(dropSticker(data, date, view)),
    moveSticker: (data, date, view) => dispatch(moveSticker(data, date, view)),
    deleteSticker: data => dispatch(deleteSticker(data)),
    resizeSticker: (data, date) => dispatch(resizeSticker(data, date)),
    onChangeStart: () => dispatch(changeStarted()),
    onChangeEnd: () => dispatch(changeEnded()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(StickerDrop);
